import React from "react";
import {Chip, Tooltip} from "@mui/material";
import {useTranslation} from "react-i18next";

const ComparisonChip = ({ comparisonMode, setComparisonMode, disabled, onClick }) => {
    const {t} = useTranslation(["webgis"]);

    const handleClick = () => {
        if (onClick) {
            onClick();
        } else {
            setComparisonMode(!comparisonMode);
        }
    }

    return (
        <Tooltip title={disabled ? t('comparisonTooltip') : ''}>
            <span>
                <Chip
                    size="small"
                    label={t('compare', 'Compare')}
                    onClick={handleClick}
                    color={comparisonMode ? "info" : "default"}
                    variant={comparisonMode ? "filled" : "outlined"}
                    sx={{ borderRadius: '16px' }}
                    disabled={disabled}
                />
            </span>
        </Tooltip>
    );
};

export default ComparisonChip;
